module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/24.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("MASK 1")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Shame")]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-subtitle"
  }, [_c('em', [_vm._v("Finding Worth as an Image Bearer")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/design1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("The shame that tormented me was all the more corrosive for having no very clear origin: I didn’t know why I felt so tainted, and worthless, and wrong—only that I did, and whenever I looked up from my books I was swamped by slimy waters rushing in from all sides.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("— Donna Tartt, "), _c('em', [_vm._v("The Goldfinch")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("Humanity is a plague. We’re a disgusting, narcissistic, selfish parasite, and the world would be a better place without us.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("— Tony, as played by Ricky Gervais in "), _c('em', [_vm._v("After Life")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("You have made them a kingdom and priests to our God, and they shall reign on the earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("— the twenty-four elders in the book of Revelation")])]), _c('h1', {
    staticClass: "sec1c"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("ANGEL")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "imagec1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SIT")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YOUNG")]), _vm._v(" woman. She exhales and looks at her shoes. “My grandfather molested me when I was six. My father first raped me when I was eleven. Abusive boyfriends took his place by the time I was thirteen. Alcohol, drugs, men. It’s been the story of my life.” She looks up at me flatly. “Nothing works. I hate myself. I am worthless.”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/design2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("John got the call from Brian’s mother this morning. “He committed suicide last night.” John’s heart drops and he remembers their last session. “My kids would be better off without me,” he said. “My wife has moved on. She already has a boyfriend. She won’t even look me in the eye.” Brian made assurances that he would not commit suicide. But as he sat in his truck pulled off to the side of the road, looking at the home he had been forced to sell when he and his wife separated, his emotions probably churned inside of him. He might have remembered the first day they moved in, with all their hopes and aspirations. His thoughts may have drifted to teaching his kids how to ride their bikes, to a fight he and his wife had, to a piñata hung up on a mesquite tree for a birthday party. And in the end, he believed the world was a better place without him.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/design2.jpg"
    }
  })])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("The American Psychological Association reports that suicide rates have increased 30 percent in the past two decades.")]), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_5",
      "id": "note-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" In the age group of fifteen-to twenty-four-year-olds, the rate of increase is a staggering 56 percent."), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_6",
      "id": "note-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("How can self-hatred be so pervasive in this age of self-positivity? "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The rise of suicide rates has directly correlated with the rise of social media.")]), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_7",
      "id": "note-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" John and I don’t think that is a coincidence. Never in the history of the world has there been a time when we all are more susceptible to the dangerous trap of comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When we grew up, we compared ourselves with classmates and neighbors. Today, via social media, we compare ourselves to virtually any acquaintance we’ve ever had. And that comparison is poisonous. No matter how great our lives might be, one glance on social media is sure to remind us that someone out there has a better life than we do. A discouraging day is compounded by social media, where we are sure to see friends in some exotic location.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("The Voice of Shame")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("Many of us live with a voice that speaks words of despair into our ears: “I am a fraud.” “I am so messed up.” “I am stupid.” “I am pathetic.” “I am worthless.” And the you messages: “You suck.” “Everyone knows you’re an idiot.” “Who do you think you are?” “Everyone thinks you are such a loser.” “No one will ever want you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This shame attendant has been present since the relationship between humans and God ruptured. One of the reasons we feel shame is because God has an enemy (and therefore we do too!). His name is Satan, and he’s the accuser and tempter of human beings. Shame is Satan’s most powerful tool to estrange us from God and to multiply the power of sin in our lives. When Adam and Eve rejected God’s authority in their lives and chose to eat of the Tree of Knowledge of Good and Evil, what was their immediate response? Shame. Suddenly aware of their nakedness, they hid their bodies. Guilty of what they had done and ashamed of who they were, they hid from their Maker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This is what shame does: it alienates us from one another and from God. While guilt is our response to what we have done, shame tells us that we "), _c('em', [_vm._v("are")]), _vm._v(" what we have done. Gripped with the fear of "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("what we will see if we encounter ourselves, we hide from ourselves, others, and God.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The voice of shame records fragments of conversations with others that echo our worst fears about ourselves and plays them on a loop. John has told me horror stories of the many times he’s heard, in the chambers of his heart, the echo of an elder’s words at a church he pastored: “You are unfit for ministry.” The context of that statement is wiped out; John’s heart ignores how he’s changed since then. Instead, he feels the words aimed like a bony finger at his chest, accusing him, defeating him.")]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('strong', [_vm._v("The voice of shame records fragments of conversations that echo our worst fears about ourselves and plays them on a loop.")])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The voice of shame also takes even small events and attaches messages to them. We write a text message to a friend that is reciprocated with silence. “You aren’t worth his time,” the voice tells us. Yesterday John spoke to a group of pastors, and no one followed up with a text or email. “You should have declined the invitation to speak. Now they know you are an imposter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It happens in anticipation as well. Invited to speak to a group of pastors, I have heard the voice of shame speak to me: “You’re stupid. What do you have to offer these older, wiser men?” The voice speaks to us both as we write this book: “Who do you think you are? You’re not authors. No one will read this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once Satan instigates shame, he hands us fraudulent tools to escape its imprisonment: comparison, comfort, and numbing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If you just compare yourselves to others who are worse, you will feel better,” he lies. “Console yourself with this bowl of ice cream,” he coos. “Ease your pain with this porn,” he entices. “Shut down so you don’t have to feel these bad feelings,” he whispers.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The shame attendant rubs his hands together when we cave to comparison, comfort, and numbing. Scrolling social media creates more fodder for shame, as does the bowl of ice cream, masturbation, and numbing. Shame wants us to stop, to freeze, to shrink.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Our flesh goes to great lengths to avoid pain and seek comfort. The danger and irony of shame language is that it arrogantly dismisses God. Shame plugs our ears from hearing the voice of God and refuses his truth about who we are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Amplifying the voice of shame can feel as though we are acting in humility. But it is not humble to believe lies. It is not humble to reject what God says about us. It is sinful to deny God’s words over us; when we do, we position ourselves on the enemy’s battlefield in allegiance with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("How do we break the cycle of shame? How do we fight the voice that tells us we are worthless?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("The First Word")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("To shut down the lies of shame, we must open our ears to the truth God speaks to us. The first word on who we are in the Bible is a word that speaks to our incredible value. In the first chapter of the first book of the Bible, Genesis 1, the story of creation is laid out before us. As God creates the cosmos, he revels in its beauty and perfection. Punctuating each of God’s creations is God’s delight in his creation: “God saw that it was good.” Stars and planets, saguaros and palm trees, centipedes and elephants … God smiles and laughs. “Good, good, good!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But God is not finished. The stage is set, but the lead actors are not in place.")])]), _c('p', {
    staticClass: "ext1"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Then God said, “Let us make man in our image, after our likeness. And let them have dominion over the fish of the sea and over the birds of the heavens and over the livestock ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("and over all the earth and over every creeping thing that creeps on the earth.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "ext-indent"
  }, [_vm._v("So God created man in his own image,")]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent1"
  }, [_vm._v("in the image of God he created him;")]), _vm._v(" "), _c('p', {
    staticClass: "ext-indent1"
  }, [_vm._v("male and female he created them. (vv. 26–27)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("As a human being, you hold the unique distinction of bearing the image of the Almighty, the Creator. You were created in God’s image. You have permission to declare with confidence, “Hi, my name is [fill in the blank], and I am an image bearer of God Almighty!” This is true. “I am worthless” is a lie. Receiving our identity as an image bearer of God gives us permission to be freed from the prison of shame.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We are invited to look into the mirror of God himself—not the mirror of our expectations, not the mirror of society or media, not the mirror of family, friends, and acquaintances—and see that God says we are “very good” (v. 31). God’s first word about all of us is that we are good.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When you look in the mirror with disdain, when you hate how you look or that you’re not smart enough, you are not speaking of who you are—you are speaking of who God is. Self-hatred is God-hatred.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The story of the creation of Adam and Eve concludes with these words: “And the man and his wife were both naked and were not ashamed” (2:25). God made you to be naked and unashamed. Author Curt Thompson writes that shame “wants to destroy everything about the world that God intended for goodness and beauty.”")]), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_8",
      "id": "note-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" One day, free of sin and with the shame attendant’s voice banished to hell, you will experience the glory of a life free of shame.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("A Masterpiece?")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("Who is your favorite artist? Da Vinci? Van Gogh? Picasso? Imagine that a benefactor gave you one of their masterpieces. In your living "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("room hangs Da Vinci’s "), _c('em', [_vm._v("Mona Lisa")]), _vm._v(", or Van Gogh’s "), _c('em', [_vm._v("Starry Night")]), _vm._v(", or Picasso’s "), _c('em', [_vm._v("Les Demoiselles D’Avignon")]), _vm._v(". You invite a friend over for dinner. You welcome him at the door, and he steps into your living room. His eyes squint and his nose turns up. “What’s that ugly piece of trash?” he says.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What is your response? Do you take your friend seriously? Have you misjudged the work of art? Or do you recognize that while you have a masterpiece, you also have a friend with poor judgment?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You were created by "), _c('em', [_vm._v("the")]), _vm._v(" Master Artist. Better than Da Vinci’s "), _c('em', [_vm._v("Mona Lisa")]), _vm._v(", better than Van Gogh’s "), _c('em', [_vm._v("Starry Night")]), _vm._v(", better than Picasso’s "), _c('em', [_vm._v("Les Demoiselles D’Avignon")]), _vm._v(", are "), _c('em', [_vm._v("you")]), _vm._v(", the masterpiece of the Master Artist. So when you look in the mirror and think awful things about who you are, your inner voice is acting like that imaginary friend who criticized the masterpiece in your living room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Our self-hatred speaks of our misjudgment, not of the flawed artistry of the Master Artist. God looks at you, his masterpiece, and says, “You are very good!” He’s not a liar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Not only are you God’s masterpiece, but Genesis 1:27 says you are made in his image. What does it mean for you to image God? There are three primary ways you do so. First, you image God’s "), _c('em', [_vm._v("attributes")]), _vm._v(". Second, you image God’s "), _c('em', [_vm._v("relationality")]), _vm._v(". Third, you image God’s "), _c('em', [_vm._v("reign")]), _vm._v(".")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("You Image God’s Attributes")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("You image the attributes of the one true God. The Bible tells us those attributes include God’s")])]), _c('ul', [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('li', [_vm._v("holiness (Isa. 6:1–8)")]), _vm._v(" "), _c('li', [_vm._v("goodness (Ps. 34:8)")]), _vm._v(" "), _c('li', [_vm._v("justice (Jer. 23:5)")]), _vm._v(" "), _c('li', [_vm._v("love (1 John 4:7–19)")]), _vm._v(" "), _c('li', [_vm._v("grace (John 1:17)")]), _vm._v(" "), _c('li', [_vm._v("mercy (Ps. 103)")])]), _c('li', [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("faithfulness (2 Tim. 2:13)")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('li', [_vm._v("wisdom (James 1:5–6)")]), _vm._v(" "), _c('li', [_vm._v("freedom (Exod. 3:14)")]), _vm._v(" "), _c('li', [_vm._v("beauty (Ps. 27:4)")])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Each of these attributes is reflected in you. Go through each characteristic and ask whether you can see it in yourself. (If you’re not sure what a word means, or even if you think you know, look it up in a dictionary or Google it.) Can you see God’s mercy in you? His goodness? His justice? Wherever you see these attributes, you see the reflection of the Master Artist in you.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("In "), _c('em', [_vm._v("The Help")]), _vm._v(", the maid Aibileen Clark speaks a blessing over the child she is caring for: “You is kind. You is smart. You is important.”")]), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_9",
      "id": "note-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" That’s what God says about "), _c('em', [_vm._v("you")]), _vm._v(". When he sees you, he sees his own attributes and image reflected in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang-t"
  }, [_vm._v("When you resist the temptation to finish the Ben and Jerry’s pint to numb your pain, God sees his holiness in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you do what is right and claim tips on your taxes, God sees his goodness in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you use your voice for someone mistreated, God sees his justice in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you cradle your colicky newborn, God sees his love in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you offer forgiveness to your friend who gossiped about you, God sees his grace in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you release someone from a debt, God sees his mercy in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you choose to go to counseling to preserve your marriage, God sees his faithfulness in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When you say no to entertainment because of a looming test, God sees his wisdom in you.")]), _vm._v(" "), _c('p', {
    staticClass: "ref-hang"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("When you refuse to engage in crude joking, God sees his freedom in you.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "ref-hang"
  }, [_vm._v("When your joyful laugh fills a room, God sees his beauty in you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("You were made to reflect the attributes of God to a world desperately in need of them. In a world that aches for justice, truth, love, mercy, and beauty, God has placed you to magnify his perfect attributes.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("You Image God’s Relationality")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("Christianity claims that God is triune. The word "), _c('em', [_vm._v("triune")]), _vm._v(" means that the one true God has existed eternally in perfect relational unity: the Father, the Son, and the Holy Spirit. As human beings created in God’s image, we display all the three persons of the Trinity: the Father, Son, and Holy Spirit. We also reflect their triune relationship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Father says you were fashioned perfectly from the beginning. You were formed in secret. Woven in the depths of the earth. The Father says he saw your unformed substance and wrote in the book of life every one of your days (Ps. 139:15–16).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Son died so his blood could make you right before him. The Son, who knew no sin, became sin, so you could be made righteous (2 Cor. 5:21). Jesus looks upon you as the “joy that was set before him” (Heb. 12:2) on his road to Golgotha.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Holy Spirit dwells intimately in you so that not only do you have a helper 24-7, but you can also be made alive and go forth in the power of his name (Rom. 8:11).")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("As image bearers, we reflect the relationality of our triune God. From eternity, God is in community. And he makes us for community. In Ephesians 2, Paul explains that those who have trusted Christ have been saved by grace through faith and then brought into community through the peace of Christ. He concludes that we ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("“are being built together into a dwelling place for God by the Spirit” (v. 22). We display who God is when we are together. He made us for one another, and as we love one another and are united in heart and mind, we reflect his triune character.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('h1', {
    staticClass: "sec1"
  }, [_vm._v("You Image God’s Reign")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("Dominion.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("If you take a look at the verses we quoted on ")]), _c('a', {
    attrs: {
      "href": "#/#page_29"
    }
  }, [_vm._v("pages 29–30")]), _vm._v(" about the creation of mankind, you’ll see that "), _c('em', [_vm._v("dominion")]), _vm._v(" is the first word about how you reflect God’s image. You are the image bearer of the high King of Kings, intended to “have dominion over” (we will return to this theme in greater depth in "), _c('span', {
    attrs: {
      "href": "#/016_Mask9#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v("). Having dominion means God gives us authority to oversee, nurture, and steward that which he has given us responsibility for. You are set apart from creation and intended for a higher purpose. You are the unique and beautiful actor God created for his stage to reflect himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first way we reflect God’s image is by reflecting his benevolent rule on earth: we reign, but we do so in a way that’s best for everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We live out dominion in our workplaces, in parenting, over finances, in the kitchen, and in our neighborhoods. When we are employees who work hard, are filled with integrity, and treat people in front of us as fellow image bearers of God, we practice dominion as God intended. As we discipline our children in unity, mercy, and grace, we display God’s dominion. Dominion can be shared. In marriage, when we jointly make purchasing, banking, and budgeting decisions, we demonstrate dominion. When we collaboratively cook a delicious meal, we steward God’s gift of cuisine. As we open our home in hospitality to our neighbors, we exercise dominion in the place we live.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One of John’s and my favorite shared things to do is to practice "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("dominion in the space God has given us. We love stepping outside to cultivate our yard into a place of beauty. We dig the soil, pot a plant, pick weeds, and prune trees. As we work, we inhale gratitude and exhale prayers of surrender. “It is good,” we tell our King as we care for his garden.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Humans were made for dominion. We are servants who have been given talents (giftings, finances, and opportunities) from our Master with a call to steward them for his glory (Matt. 25:14–30). It is life giving when we understand who we are and give ourselves permission to see ourselves from God’s point of view.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You are made to reign and reflect his kind rule. You are his king. You are his queen.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("The Last Word")]), _vm._v(" "), _c('p', {
    staticClass: "para0"
  }, [_vm._v("God undoes shame not just with his first word about us from creation but also with his last word on the cross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It is finished,” Jesus declares in his final moments. On the cross Jesus speaks the last word to shame as he identifies with our shame and removes its power. The Enemy’s whispers of shame are silenced as Jesus purchases us with his blood. Our sin—rejecting God in thought, word, or action—doesn’t define us; his acceptance of us does. The sinless man becomes sin that we might be freed from sin. The unshameable man becomes shame that we might be freed from shame. Like the sponge he’s given to drink from, Jesus is saturated in sin and shame. The shaming of the perfect man undoes shame.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Satan went into his bag of tricks and pulled out the most powerful one he had: shame. It was a ploy that had proved effective time and time again. He must have howled in delight to use it on the very Son of God.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("God undoes shame on Good Friday. The story of the cross is not merely the story of guilt being removed but of shame being undone. ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("The Romans devised crucifixion not just to torture those they killed but also to inflict shame in the process. The victim hung completely naked on the torture device, arms outstretched and unable to cover himself.")]), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_10",
      "id": "note-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_c('strong', [_vm._v("The story of the cross is not merely the story of guilt being removed but of shame being undone.")])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the cross, Christ makes atonement for our sin. The penalty is paid by the blood of the God-man poured out on the cross. But the work of Christ does not end there; Jesus takes the full sting of shame on the cross and removes its poison.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Christ’s arrest begins with a kiss by one of his closest friends, an act of respect and intimacy used to bring the shame of betrayal. He is abandoned by all but two of his friends: more shame. One of his closest friends then denies him: additional shame. The spiritual authorities place him on a bogus trial: shameful. The political authorities put him on trial: shame. The crowds turn against Christ, mocking him, begging for an insurrectionist to be released instead of him and demanding his crucifixion: shame multiplies. He is stripped naked, mocked as king, and spat upon: shame deepens. Through a crowd, he drags a cross to Golgotha and is hung between two enemies of the state who also mock him: shame mounts. He hangs naked as the soldiers gamble for his clothing: shame. He cries out to God, publicly expressing his hurt, fear, and forsakenness: shame culminates.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the road to the cross, Jesus walks into the heart of shame. He has plunged deeper into shame than we could ever imagine and has destroyed the Enemy’s weapon of shame. Just as Christ absorbed our sin on the cross, he also absorbs our shame. Satan will seek to destroy us through shame, but because of the cross, that shame is "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("a lie and has no ultimate power. Satan will attack, but “no weapon that is fashioned against you shall succeed” (Isa. 54:17). We can walk the path as image bearers without shame because Jesus, the perfect image bearer, has already walked the path of shame for us on the cross.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Jesus knows the shame you have experienced. Because he has walked its path, you are no longer bound by its lies. Dane Ortlund frames this explosive truth this way: “That God is rich in mercy means that your regions of deepest shame and regret are not hotels through which divine mercy passes but homes in which divine mercy abides. It means the things about you that make you cringe most, make him hug hardest.”")]), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_11",
      "id": "note-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" The cross reveals the heart of God. God is not repulsed by our shame. The Merciful One knows you and loves you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("You are not worthless. You bear the image of the almighty God, the creator of the universe. The cross of Christ speaks of your worth. You are worth the life of the very Son of God, Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("When we open our ears to hear the voice of God, the voice of shame is silenced. When we hear God speak his truth over our lives, we step out of patterns of comparison, self-comfort, and numbing, and we move forward in his love. Psychologist Curt Thompson says, “Where shame attempts to push us into static inertia, love bids us to "), _c('em', [_vm._v("move")]), _vm._v(".”"), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_12",
      "id": "note-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Shame tries to steal the pen from the great Author and rewrite his stories in our lives. Let God take back the pen of your story. God authors a story “of hope and creativity, one that scorns shame in order to imagine new minds, new possibilities and new narratives.”"), _c('span', {
    attrs: {
      "href": "#/021_endnotes#note_13",
      "id": "note-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Step into God’s kingdom story as his image bearer, and live in the power and truth of his words over you, words he has spoken from creation and from the cross. Will you receive them? Make a choice today to trust him. Make a choice today to die to a false self. "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Make a choice to take off any jersey that would name you with self-condemnation and put on a jersey that speaks God’s truth: you are worthy, redeemed, holy, beautiful, valuable, loved, and established.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "box-head"
  }, [_vm._v("PRAYER")])]), _c('p', {
    staticClass: "bpara"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('em', [_vm._v("Father, forgive me for so easily dismissing you and who you say I am. I bear your image. Forgive me for listening to the lies of shame. I receive the gift of Jesus on the cross, who took my shame and set me free from its burden. Jesus, your blood purifies me. Forgive me for the lies I speak over myself. Forgive me for the ways in which I condemn myself. Lord, I repent of the specific lies shame has convinced me are true. I am not stupid. I am not ugly. I am not a loser. I am not worthless. You say I am worthy, I am redeemed, I am holy, I am beautiful, I am valuable, I am loved, and I am established. I receive your truth for myself. Teach me to hear your voice. Teach me to be satisfied in you, holy God. Teach me to trust whatever you call me into today. You anoint, equip, and empower me to be who I am. I am yours. Thank you that I can walk in the blessing of being made in your image and say, with you, that it is very good. Amen.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c551348","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Mask1.vue
// module id = 78
// module chunks = 0